export default "__VITE_ASSET__3185f218__"